<form [formGroup]='campaignDraft.campaignForm' (ngSubmit)="campaignDraft.doSave('general.saveSuccess')"
      class='mb-1' novalidate>
  <ng-container *ngIf="campaignDraft.rejectedAdverts() as rejectedNums">
    <ngb-alert *ngIf="rejectedNums.length" type="danger" [dismissible]="false">
      <div *ngFor="let num of rejectedNums">
        {{ 'campaign.adRejected.explanationGeneral' | translate : {'id': num} }}
      </div>
    </ngb-alert>
  </ng-container>
  <ng-container *ngIf="campaignDraft.products.length > 1">
    <h2>{{ 'campaign.product.title' | translate }}</h2>
    <ngb-alert *ngIf='campaignDraft.wasProductDeleted()' [dismissible]='false'
               [innerHTML]="'campaign.product.deleted' | translate"></ngb-alert>
    <div class="loading-overlay-parent">
      <div *ngIf="showLoadingOverlays()" class="loading-overlay" [ngStyle]="{'cursor':'default'}"></div>
      <app-product-selection [campaignDraft]="campaignDraft"></app-product-selection>
    </div>
  </ng-container>
  <div class="loading-overlay-parent">
    <div *ngIf="showLoadingOverlays()" class="loading-overlay"></div>
    <ng-container *ngIf='campaignDraft.getProduct() as product'>
      <hr>
      <h2>{{ 'campaign.ad.topTitle' | translate }}</h2>
      <table class="table tableNormalised">
        <thead>
        <tr>
          <th>{{ 'field.objectName' | translate }}</th>
          <th>{{ 'campaign.ad.details' | translate }}</th>
          <th>{{ 'campaign.ad.details' | translate }}</th>
        </tr>
        </thead>
        <tbody>
        <tr *ngFor="let adDraft of campaignDraft.advertDrafts; let i = index" [ngClass]="{'table-active': advertIndex === i && campaignDraft.advertDrafts.length > 1}" class="align-middle">
          <td>
            <div>{{ adDraft.creative.name }}</div>
          </td>
          <td>
            <div>
              <span *ngIf="adDraft.creative.width" class='badge bg-primary me-1'>{{ adDraft.creative.width }}x{{ adDraft.creative.height }}</span>
              <span *ngIf="adDraft.creative.isNew">
                <span class="badge bg-primary">New</span>
              </span>
              <span *ngIf="!adDraft.creative.isNew">
                <span class="badge bg-success" *ngIf="adDraft.creative.uiStatus === 'VALID'">{{ 'campaign.ad.valid' | translate }}</span>
                <span class="badge bg-danger" *ngIf="adDraft.creative.uiStatus === 'INVALID'">{{ 'campaign.ad.invalid' | translate }}</span>
                <span class="badge bg-danger" *ngIf="adDraft.creative.userState === 'REJECTED'">{{ 'campaign.status.REJECTED' | translate }}</span>
              </span>
              <span *ngIf="!adDraft.advertForm.pristine">
                <span class="badge bg-info">{{ 'campaign.ad.unsaved' | translate }}</span>
              </span>
            </div>
          </td>
          <td>
            <div style="display: inline-block">
              <button type="button" class="btn btn-sm" [id]="'viewEdit' + i" [ngClass]="{'btn-dark': advertIndex === i, 'btn-outline-dark': advertIndex !== i}" (click)="viewClick(i)">
                <span><i class="fas" [ngClass]="{'fa-arrow-down': advertIndex === i, 'fa-arrow-up': advertIndex !== i}"></i> {{ 'campaign.ad.viewEdit' | translate }}</span>
              </button>
            </div>
            <div style="display: inline-block">
              <button type="button" [id]="'copy' + i" [disabled]="campaignDraft.advertDrafts.length >= MAX_CREATIVES" class="btn btn-outline-dark btn-sm" (click)="copyClick(i)">
                <i class="fas fa-edit"></i>
                {{ 'label.copy' | translate }}
              </button>
            </div>
            <app-remove-creative [advertDraft]="adDraft" [theId]="i"></app-remove-creative>
          </td>
        </tr>
        </tbody>
      </table>
      <p class="text-end">
        <app-add-creative id="addCreative" [advertDraft]="campaignDraft.advertDrafts[0]" (click)="addMade()"></app-add-creative>
      </p>
      <div *ngIf='campaignDraft.numVisibleCreatives(campaignDraft.campaignForm) >= MAX_CREATIVES'
           class='text-end mb-3 small'>
        {{ 'campaign.ad.maximum' | translate: {max: MAX_CREATIVES} }}
      </div>
      <ng-container *ngFor="let adDraft of campaignDraft.advertDrafts; let i = index">
        <div *ngIf="i === advertIndex">
          <app-creative-editor [productData]="productData" [advertDraft]="adDraft" [showLoadingOverlays]="showLoadingOverlays()"></app-creative-editor>
          <div class="loading-overlay-parent">
            <div *ngIf="showLoadingOverlays()" class="loading-overlay"></div>
          </div>
        </div>
      </ng-container>
      <hr>
      <div class="loading-overlay-parent">
        <div *ngIf="showLoadingOverlays()" class="loading-overlay"></div>
        <app-campaign-details [campaignDraft]="campaignDraft"></app-campaign-details>
        <ngb-alert
          *ngIf='campaignDraft.lineItemReview.lineItem.objectState === "ACTIVE" && !showSubmitCampaignComponent() && campaignDraft.campaignForm.pristine'
          [dismissible]='false'>
          <div [innerHTML]="'campaign.validationProblemsPresent' | translate"></div>
        </ngb-alert>
        <app-submit-campaign *ngIf="showSubmitCampaignComponent()" [campaignDraft]="campaignDraft"
                             (isSubmitting)="isSubmitting=$event">
        </app-submit-campaign>
        <ngb-alert *ngIf="campaignDraft.anon" type='info' [dismissible]="false">
          <span [innerHTML]="'campaign.anon.beforeText' | translate"></span><a
          [routerLink]="configService.getUrl('/sign-in/register')"
          [innerHTML]="'campaign.anon.linkText' | translate"
        ></a><span [innerHTML]="'campaign.anon.postText' | translate"></span>
        </ngb-alert>
        <div class='text-center'>
          <button type='submit' name='save-your-progress' class='btn btn-outline-dark btnSaveCampaign'
                  [disabled]='campaignDraft.campaignForm.pristine'>
            {{ 'campaign.save.button' | translate }}
          </button>
          <button type='button' class='btn btn-link' (click)='campaignDraft.onUndo()'
                  [disabled]='campaignDraft.campaignForm.pristine'>
            {{ 'button.undo' | translate }}
          </button>
        </div>
      </div>
    </ng-container>
  </div>
  <ng-container *ngIf='createMissingCreative$ | async as result'>
    <ngb-alert *ngIf="result.errorKey" type='danger' [dismissible]="false">{{ result.errorKey | translate }}
    </ngb-alert>
  </ng-container>
</form>


